
  import { mapGetters } from 'vuex';

  export default {
    middleware: ['pages/products/banking/prepay-cards/show', 'breadcrumbs', 'meta-tags'],
    meta: { category: 'banking', metaTagOptions: { image: 'prepay-cards' } },
    data () { return { expanded: {} }; },
    computed: {
      ...mapGetters('products', { card: 'get' }),
      displayName () {
        return this.card ? [this.card.institution.name, this.card.name].join(' ') : null;
      }
    },
    methods: {
      toggleExpanded (key) {
        const newValue = {};
        newValue[key] = !this.expanded[key];
        this.expanded = { ...this.expanded, ...newValue };
      },
      topupFee (type) {
        let fee = this.card[`topup_${type}_text`] || this.card[type];
        if (typeof fee === 'number') {
          return (fee <= 0) ? 'FREE' : this.$n(fee, 'currency');
        }
        return 'n/a';
      }
    }
  };
